import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import UserHeader from "./UserHeader";
import { apiFetch } from "../api_call";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";


export default function FinalEdit() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    compliance_id: "",
    compliance_name: "",
    start_date: "",
    end_date: "",
    comply_by: "",
    description: "",
    reminder_days: 1,
    escalation_email: "",
    escalation_reminder_days: "",
  });

  const [successMsg, setSuccessMsg] = useState("");
  const [errors, setErrors] = useState({});
  const [errorVisible, setErrorVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  
  // 🔹 Convert any date to YYYY-MM-DD
  const toInputDate = (dateStr) => {
    if (!dateStr) return "";
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };

  // 🔹 Fetch edit data
  useEffect(() => {
    const regcmpId = localStorage.getItem("regcmpId");
    if (!regcmpId) return;

    const fetchEditData = async () => {
      try {
        const res = await apiFetch(
          `/compliance/edit/regulatory/${regcmpId}`,
          { method: "GET" }
        );

        const row = res?.data;
        if (!row) return;

        setFormData({
          compliance_id: row.regcmp_compliance_id || "",
          compliance_name:
            row.regcmp_act ||
            row.regcmp_title ||
            row.regcmp_particular ||
            "",
          start_date: toInputDate(row.regcmp_start_date),
          end_date: toInputDate(row.regcmp_end_date),
          comply_by: toInputDate(row.regcmp_action_date),
          description:
            row.regcmp_description || row.regcmp_long_description || "",
          reminder_days: Number(row.regcmp_reminder_days || 1),
          escalation_email: row.regcmp_escalation_email || "",
          escalation_reminder_days: row.regcmp_escalation_reminder_days || "",
        });
      } catch (err) {
        console.error("Failed to fetch edit data:", err);
        setErrors({ api: "Failed to load compliance details." });
      }
    };

    fetchEditData();
  }, []);

  // 🔹 Editable fields handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setSuccessMsg("");
    setErrors({});
  };
  // 🔹 Helper to convert YYYY-MM-DD -> DD-MM-YYYY for API
const toAPIDate = (dateStr) => {
  if (!dateStr) return "";
  const [yyyy, mm, dd] = dateStr.split("-");
  return `${dd}-${mm}-${yyyy}`;
};


  // 🔹 Submit update
  const handleSubmit = async (e) => {
    e.preventDefault();
     window.scrollTo({ top: 0, behavior: "smooth" });

    setSuccessMsg("");
    setErrors({});

    const regcmpId = localStorage.getItem("regcmpId");
    if (!regcmpId) {
      setErrors({ api: "Compliance ID missing" });
      return;
    }

    const payload = {
  regcmp_action_date: toAPIDate(formData.comply_by),
  regcmp_reminder_days: Number(formData.reminder_days),
  regcmp_escalation_email: formData.escalation_email || null,
  regcmp_escalation_reminder_days:
    formData.escalation_reminder_days !== ""
      ? Number(formData.escalation_reminder_days)
      : 0,
};


    try {
      const res = await apiFetch(
        `/compliance/edit/regulatory/${regcmpId}`,
        {
          method: "PUT",
          body: JSON.stringify(payload),
        }
      );

      if (res?.message === "Compliance updated successfully") {
  setSuccessMsg("✅ Compliance updated successfully");

  // 🔹 Navigate only on success
  setTimeout(() => {
    navigate("/edit-compliance");
  }, 1000);
} else {
  setErrors({ api: "❌ Update failed" });
}

    } catch (err) {
      console.error("Update failed:", err);
      setErrors({
        api:
          err?.response?.data?.error ||
          "❌ Only pending compliances can be edited",
      });
    }
  };

  // 🔹 Auto-hide error
  useEffect(() => {
    if (errors.api) {
      setErrorVisible(true);
      const timer = setTimeout(() => setErrorVisible(false), 4500);
      const removeTimer = setTimeout(() => setErrors({}), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [errors.api]);

  // 🔹 Auto-hide success
  useEffect(() => {
    if (successMsg) {
      setSuccessVisible(true);
      const timer = setTimeout(() => setSuccessVisible(false), 4500);
      const removeTimer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => {
        clearTimeout(timer);
        clearTimeout(removeTimer);
      };
    }
  }, [successMsg]);

  const formatDDMMYYYY = (value) => {
  if (!value) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [yyyy, mm, dd] = value.split("-");
    return `${dd}/${mm}/${yyyy}`;
  }
  return value;
};


  return (
    <div className="add-user">
      <UserSidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <UserHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

      <div className="form-container">
        <h2>Edit Compliance</h2>

        <div
          className="messages-top"
          style={{ margin: "0 auto 1rem auto", width: "50%" }}
        >
          {errors.api && (
            <div
              className={`login-error ${
                !errorVisible ? "fade-out" : ""
              }`}
            >
              {errors.api}
            </div>
          )}
          {successMsg && (
            <div
              className={`success-msg ${
                !successVisible ? "fade-out" : ""
              }`}
            >
              {successMsg}
            </div>
          )}
        </div>

        <form onSubmit={handleSubmit} className="add-user-form">
          {/* 🔒 Locked fields */}
          <label className="locked-field">
            Compliance ID
            <input type="text" value={formData.compliance_id} disabled />
          </label>

          <label className="locked-field">
            Compliance Name
            <input type="text" value={formData.compliance_name} disabled />
          </label>

          <label className="locked-field">
  Start Date
  <input
    type="text"
    value={formatDDMMYYYY(formData.start_date)}
    disabled
  />
</label>

<label className="locked-field">
  End Date
  <input
    type="text"
    value={formatDDMMYYYY(formData.end_date)}
    disabled
  />
</label>


          <label>
            Comply By (Action Date)
            <input
              type="date"
              name="comply_by"
              value={formData.comply_by}
              onChange={handleInputChange}
            />
          </label><label></label>

          <label className="locked-field">
            Description
            <textarea
              value={formData.description}
              disabled
              className="textarea-like-input"
            />
          </label><label></label>

          {/* ✅ Editable fields */}
          <label>
            Reminder Days
            <input
              type="number"
              name="reminder_days"
              min="1"
              value={formData.reminder_days}
              onChange={handleInputChange}
              style={{ width: "60px" }}
            />
          </label><label></label>

          <label >
  Escalation Email
  <input
    type="email"
    value={formData.escalation_email}
  />
</label>


         <label >
  Reminder of Escalation Email
  <input
    type="number"
    value={formData.escalation_reminder_days}
  />
</label>


          <button type="submit" className="submit-btn">
            Update Compliance
          </button>
        </form>
      </div>
    </div>
  );
}
